import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FILTER_VARIANT_API } from "./apiRoutes";

interface mutateProps {
  id: string;
}

const mutateDeleteFilterVariants = async ({
  id
}: mutateProps) => {
  return await axiosAuth.delete(`${FILTER_VARIANT_API}/${id}`);
};

const useDeleteFilterVariantsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteFilterVariants,
    ...queryParams,
  });

export default useDeleteFilterVariantsMutation;
